<template>
    <NuxtLink
        class="text-16/120 font-semibold transition-colors duration-150 hover:text-accent-400 active:text-accent">
        <slot />
    </NuxtLink>
</template>

<script setup lang="ts"></script>
